import React from 'react';

import Record from 'ui/Record/Record';

import { Button } from 'components/Button';

import MainHeader from 'components/MainHeader';

import routes from 'core/routes';
import { useNavBarHeight } from 'utils/hooks/navbar';

import AddEntityModal from 'components/Entities/AddEntityModal/AddEntityModal';
import { useStore } from 'utils/hooks/store';

import AssetsTable from './components/AssetsTable';

const Assets: React.FunctionComponent = (): React.ReactElement => {
  const navBarHeight = useNavBarHeight();
  const [openModal, setOpenModal] = React.useState(false);
  const refreshRef = React.useRef<Function | null>(null);
  const { session, assetDetails, notification } = useStore();

  const [assetsCount, setAssetsCount] = React.useState(0);

  React.useEffect(() => {
    const fetchLoadCount = async (): Promise<void> => {
      const count = await assetDetails.loadCount();
      setAssetsCount(count);
    };

    fetchLoadCount();
  }, []);

  const onClose = (created: boolean): void => {
    setOpenModal(false);
    if (refreshRef.current && created) {
      refreshRef.current();
    }
  };
  const onRefreshCallback = (callback: Function): void => {
    refreshRef.current = callback;
  };

  const handleNewButtonClick = (): void => {
    if (session.user && assetsCount >= session.user.organisation.maximumAssetsAllowed) {
      notification.enqueueErrorSnackbar('Maximum assets limit reached. Please contact us to increase your limit.');
    } else {
      setOpenModal(true);
    }
  };

  return (
    <>
      <Record
        Header={
          <MainHeader
            title="Assets"
            breadcrumbs={[
              { label: 'Assets', link: routes.dashboard.assets.toString() },
              { label: 'Overview', link: routes.dashboard.assets.toString() },
            ]}
            action={
              <Button variant="contained" size="large" onClick={handleNewButtonClick}>
                New
              </Button>
            }
          />
        }
        Content={(onError) => <AssetsTable onError={onError} onRefreshCallback={onRefreshCallback} />}
        navBarHeight={navBarHeight}
      />
      {openModal && <AddEntityModal store={assetDetails} onClose={onClose} />}
    </>
  );
};

export default Assets;
